var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionEditOutlined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 18.328V19h.672l9.542-9.543-.671-.672L5 18.328ZM6.5 21H3v-3.5L14.543 5.957l3.5 3.5L6.5 21ZM19.457 8.043l1.836-1.836a1 1 0 0 0 0-1.414l-2.086-2.086a1 1 0 0 0-1.414 0l-1.836 1.836 3.5 3.5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionEditOutlined);
export default __webpack_public_path__ + "static/media/ic_action_edit_outlined.39b36e0743a55f5bbf3ba14ba4b995cd.svg";
export { ForwardRef as ReactComponent };